import script from "./AboutSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutSection.vue?vue&type=script&setup=true&lang=ts"

import "./AboutSection.vue?vue&type=style&index=0&id=7db61918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db61918"]])

export default __exports__